import React, { Component } from 'react';
import { Field, withShouldComponentUpdate } from '../Forms';

class Textfield extends Component {
  render() {
    const { name, defaultValue, type, validate, required, id, className, placeholder, disabled } = this.props;
    return (
      <Field
        name={name}
        defaultValue={defaultValue}
        validate={validate}
        required={required}
        component={({ value, trigger, validationError, active })=> {
          return (
            <input
              id={id}
              className={className}
              disabled={disabled}
              placeholder={placeholder}
              name={name}
              value={value}
              type={type}
              onChange={(e)=> {
                let value = e.target.value;
                if(type==='number'){
                  value = parseFloat(value);
                }
                trigger([
                  { type: 'onChange', value },
                  { type: 'onValidate' },
                  { type: 'onTouched' }
                ]);
              }}
              onBlur={(e)=> {
                trigger([
                  { type: 'onDirty' },
                  { type: 'onValidate' },
                ]);
              }}
            />
          )
        }}/>
    )
  }
}

export default withShouldComponentUpdate(Textfield);



// WEBPACK FOOTER //
// ./src/app/components/Forms/fields/Textfield.js